<template>
  <div class="publications">
    <div class="columns short-description" v-if="settingsObject">
      <div class="column">
        <b-field>
          <b-input placeholder="О финансовом ателье GrottBjörn" @change="updateSettings(this.settingsObject)" v-model="settingsObject.aboutGrottbjornTitle"/>
        </b-field>
        <b-field>
          <b-input type="textarea" placeholder="Описание" @change="updateSettings(this.settingsObject)" v-model="settingsObject.aboutGrottbjornText"/>
        </b-field>
      </div>
      <div class="column photo-wrapper" v-bind:style="photoContainerStyle">
        <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteAboutGrottbjornPhoto(settingsObject.id)" v-if="settingsObject.aboutGrottbjornPhoto"/>
        <div class="centered">
          <span class="button-wrapper" @click="handleLoadPhoto" v-if="!settingsObject.aboutGrottbjornPhoto">
            <a class="button is-info">+</a>Добавить фото
            <input type="file" id='photo' @change='loadPhoto' hidden ref="loadPhotoButton"/>
          </span>
        </div>
      </div>
    </div>
    <div class="save-content-button centered">
      <button class="button save-content" @click="handleSavePublicationsData()" :disabled="disabled">{{ disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ' }}</button>
    </div>
    <h2 class="has-text-centered">Публикации</h2>
    <div class="centered">
      <span class="button-wrapper" @click="handleAddPublication">
        <a class="button is-info">+</a>Добавить публикацию
      </span>
    </div>
    <div class="publications-list columns is-multiline">
      <router-link :to="{ name: 'PublicationEditor', params: { id: publication.id} }" :key="publication.id" v-for="publication in publicationsObject"
      class="nav-item is-tab publication-item-wrapper column is-half">
        <div class="publication-item has-text-centered">
          <span class="publication-title">{{publication.title}}</span>
          <span>{{publication.description}}</span>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import deepcopy from 'deepcopy'
import uuidv4 from 'uuid/v4'

export default {
  name: 'Publications',
  data () {
    return {
      updateTimer: 0,
      disabled: false
    }
  },
  computed: {
    ...mapState(['settings', 'publications']),
    settingsObject () {
      return deepcopy(this.settings)
    },
    publicationsObject () {
      return deepcopy(this.publications)
    },
    photoContainerStyle () {
      return (this.settingsObject.aboutGrottbjornPhoto)
      ? {background: !this.settingsObject.aboutGrottbjornPhoto.base64photo ? `url(/upload/photos/${this.settingsObject.aboutGrottbjornPhoto})` : `url(${this.settingsObject.aboutGrottbjornPhoto.base64photo})`}
      : {background: ''}
    }
    // photoContainerStyle () {
    //   return this.settings.aboutGrottbjornPhoto
    //   ? {background: `url(/upload/photos/${this.settings.aboutGrottbjornPhoto})`, 'background-size': 'contain', 'background-repeat': 'no-repeat', 'background-position': 'center'}
    //   : {background: ''}
    // }
  },
  methods: {
    ...mapActions(['getSettings', 'getPublications', 'addPublication', 'updateSettings',
      'saveSettings', 'addAboutGrottbjornPhoto', 'deleteAboutGrottbjornPhoto', 'savePublicationsData']),
    loadPhoto (e) {
      const reader = new FileReader()
      reader.readAsDataURL(e.target.files[0])
      const formData = new FormData()
      const file = e.target.files[0]
      formData.set('avatar', file)
      reader.onload = (e) => {
        this.settingsObject.aboutGrottbjornPhoto = {
          base64photo: e.target.result,
          data: formData
        }
        this.addAboutGrottbjornPhoto(this.settingsObject)
      }
    },
    handleLoadPhoto () {
      if (!this.settingsObject.aboutGrottbjornPhoto) {
        this.$refs.loadPhotoButton.click()
      }
    },
    handleAddPublication () {
      this.addPublication({
        id: uuidv4(),
        isNew: true,
        text: ''
      })
    },
    handleSavePublicationsData () {
      this.saveSettings(this.settingsObject)
      .then(() => {
        this.disabled = false
        this.$toast.open({ message: 'Сохранено' })
      })
    }
  },
  created () {
    this.getSettings()
    this.getPublications()
  }
}
</script>

<style scoped>
.photo-wrapper {
  background: #eee;
  min-height: 315px;
  display: flex;
  justify-content: center;
  position: relative;
  background-position: center !important;
  background-size: contain !important;
  background-repeat: no-repeat !important;
}
.publication-title {
  width: 100%;
  font-weight: bold;
  display: inline-block;
}
.delete-icon {
  top: -5px;
  right: -5px;
}
.short-description {
  margin: 40px auto 0;
  max-width: 1200px;
  padding: 0 10px;
}
.publication-item {
  background: #eee;
  padding: 100px;
  color: #000;
}
.publication-item-wrapper {
  padding: 15px;
}
.publication-item-wrapper:hover {
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// AllPublications.vue?24f01421